import { Modal } from 'antd';

const messages = {
  'saminKey': 'شما قادر به انجام این عملیات نیستید (عدم وجود کلید سمین)',
  'noFace': 'متاسفانه چهره شما تشخیص داده نشد. لطفا از کیفیت تصویر اطمینان حاصل کرده و مجددا تلاش کنید.'
};

let showing = false;

export const makeError = (type: keyof typeof messages) => {
  if (!showing) {
    showing = true;
    Modal.error({
      className: 'app-error-modal',
      style: { fontFamily: 'var(--app-font-sans)' },
      content: messages[type],
      onCancel: () => showing = false,
      onOk: () => showing = false,
      okButtonProps: {
        style: {
          fontFamily: 'var(--app-font-sans)',
          backgroundColor: '#4C8251',
        }
      }
    });
  }
};

export default makeError;
